const Blockly = require('blockly');
const TOOLTIP = 'Page-level menu entry, without actual backing page. e.g. for "Logout" link in menu';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock reference to the block as a whole
 * @param {Object} mdcBlock Meta Data Configuration block. the group definition from blockGroupConfiguration.js
 * @param {import('blockly').Input} line1OfInputs First line of inputs, already including the Block name and the title field
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    // line2ofInputs
    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Icon Name:')
        .appendField(new Blockly.FieldTextInput(''), 'iconName')
        .appendField('  Icon Color:')
        .appendField(new Blockly.FieldTextInput(''), 'iconColor');

    blocklyBlock.setPreviousStatement(false);
    blocklyBlock.setNextStatement(false);
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    code.iconName = blocklyBlock.getFieldValue('iconName');
    code.iconColor = blocklyBlock.getFieldValue('iconColor');
    return JSON.stringify(code);
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
